<template>
    <div class="row bt-dash">
        <div class="col-12 p-0">
            <table class="w-100 table" style="border-collapse: collapse;">
                <thead>
                    <tr>
                        <th class="text-center">{{ t('Level') }}</th>
                        <th>{{ t('Price') }}</th>
                        <th>{{ t('HALO') }}</th>
                        <th>{{ t('LALO') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="priceLevel in priceLevels" :key="priceLevel.id">
                        <td>
                            <div
                                class="d-flex justify-content-center align-items-center gap-2 form-check checkbox-checked">
                                <input type="checkbox" :id="`checkbox-${priceLevel.id}`" v-model="priceLevel.priceEnable"
                                    class="form-check-input" />
                                <label :for="`checkbox-${priceLevel.id}`" style="margin-top: 12px;">{{ priceLevel.id
                                    }}.</label>
                            </div>
                        </td>
                        <td>
                            <input class="w-100" type="number" v-model="priceLevel.price" />
                        </td>
                        <td>
                            <input class="w-100" type="number" v-model="priceLevel.HALO" />
                        </td>
                        <td>
                            <input class="w-100" type="number" v-model="priceLevel.LALO" />
                        </td>
                    </tr>
                    <!-- <tr class="hover-shadow">
                        <td colspan="4" class="text-center hover-pointer" @click="addPriceLevel">
                            <h5>{{ t('Add Price Level') }} +</h5>
                        </td>
                    </tr> -->
                </tbody>
            </table>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed, watch, ref } from 'vue'
import { useProductsStore } from '@/store/management/productsStore';
import type { Product, PriceLevel } from '@/store/management/productsStore';

import { useI18n } from 'vue-i18n'
import { productPriceLevelsLanguage } from '@/core/locales/products-language'

const { t } = useI18n({
  messages: productPriceLevelsLanguage
})

const productStore = useProductsStore()
const MAX_PRICE_LEVELS = 9;

const tempActiveProduct = computed(() => {
    return productStore.getTempActiveProduct
})

const activeProductId = computed(() => {
    return productStore.getActiveProductId
})

const activeProduct = computed(() => {
    return productStore.getActiveProduct
})

const createDefaultPriceLevel = (id: number): PriceLevel => ({
    id: id,
    priceEnable: false,
    priceLevel: 'Regular',
    price: 0,
    HALO: 0,
    LALO: 0,
});

const priceLevels = ref<PriceLevel[]>(
    Array.from({ length: 3 }, (_, i) => createDefaultPriceLevel(i + 1))
);

const addPriceLevel = () => {
    if (priceLevels.value.length < MAX_PRICE_LEVELS) {
        const newId = priceLevels.value.length + 1;
        priceLevels.value.push(createDefaultPriceLevel(newId));
    }
};

watch(activeProductId, (newVal) => {
    if (newVal) {
        const productGroup = activeProduct.value
        if (productGroup && Array.isArray(productGroup.priceLevels)) {
            priceLevels.value = productGroup.priceLevels.map((pl: PriceLevel, idx: number) => ({
                ...createDefaultPriceLevel(idx + 1),
                ...pl,
                id: pl.id ?? idx + 1,
            }));
        }
    }
}, { immediate: true });

watch(priceLevels, (newVal) => {
    productStore.setTempActiveProduct({
        ...tempActiveProduct.value,
        priceLevels: newVal,
    } as Product)
}, { deep: true });
</script>

<style scoped lang="scss">
.hover-shadow {
    transition: background-color 0.3s ease;
}

.hover-shadow:hover {
    background-color: rgba(0, 0, 0, 0.05);
}
</style>